import styled from "styled-components";

export const StyledSubmissionSubmitWrapper = styled.div`
  color: var(--white);
`;
